import Rebase from 're-base'
import firebase from 'firebase/app'
import 'firebase/database'

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyA356SFnO0MC3fuGZUWAQqSCLi6yetEiXU",
  authDomain: "clubcapn-app.firebaseapp.com",
  databaseURL: "https://clubcapn-app.firebaseio.com"
})


const base = Rebase.createClass(firebaseApp.database())

// This is a named export
export { firebaseApp }

// this is a default export
export default base
